package presentation.screens.business.inventory.product.create.component

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import cafe.adriel.voyager.navigator.LocalNavigator
import component.image.CircularImageView
import feature.auth.model.FriendlyUser
import feature.product.viewModel.ProductViewModel
import feature.productCategory.viewModel.ProductCategoryViewModel
import feature.productSubCategory.viewModel.ProductSubCategoryViewModel
import presentation.screens.business.inventory.category.component.SelectCategoryCard
import presentation.screens.business.inventory.category.select.SelectCategoryScreen
import presentation.screens.business.inventory.sub_category.component.SelectProductSubCategoryCard
import presentation.screens.business.inventory.sub_category.select.SelectSubCategoryScreen

@Composable
fun CreateProductMoreInfo(viewModel: ProductViewModel) {
    val categoryViewModel = ProductCategoryViewModel()
    val subCategoryViewModel = ProductSubCategoryViewModel()
    val product = viewModel.newProduct.collectAsState()
    val selectedCategory = categoryViewModel.selectedCategory.collectAsState()
    val selectedSubCategory = subCategoryViewModel.selectedSubCategory.collectAsState()
    val navigator = LocalNavigator.current
    Column(
        modifier = Modifier.fillMaxWidth().padding(bottom = 10.dp)
    ) {
        CircularImageView(id = FriendlyUser().id, true)
        SelectCategoryCard(
            selectedCategory.value,
            selectedCategory.value
        ) {
            if (it != null) {
                categoryViewModel.selectCategory(it)
            }
            navigator?.push(SelectCategoryScreen())
        }
        SelectProductSubCategoryCard(
            selectedSubCategory.value,
            selectedSubCategory.value,
            onClick = {
                navigator?.push(SelectSubCategoryScreen())
            }
        )
    }
}